import { ISnapshot } from 'common/builder/reducers/builders/snapshots'

export function getSnapshotList(state: RootState, builderId: string) {
  return state.builders.byId[builderId].snapshots.snapshotList
}

export function getSnapshotIndex(state: RootState, builderId: string) {
  return state.builders.byId[builderId].snapshots.snapshotIndex
}

export function getSnapshotInstallationStatus(state: RootState, builderId: string) {
  return state.builders.byId[builderId].snapshots.isSnapshotInProgress
}

export function getCurrentSnapshot(state: RootState, builderId: string) {
  const currentIndex = getSnapshotIndex(state, builderId)
  const snapshotList = getSnapshotList(state, builderId)
  return snapshotList[currentIndex]
}

export function getTargetSnapshot(state: RootState, builderId: string, index: number): ISnapshot {
  const snapshotList = getSnapshotList(state, builderId)
  return snapshotList[index]
}

export function getUndoStatus(state: RootState, builderId: string) {
  const snapshots = getSnapshotList(state, builderId)
  const snapshotIndex = getSnapshotIndex(state, builderId)
  const isSnapshotInProgress = getSnapshotInstallationStatus(state, builderId)
  const isEmptyList = !snapshots.length
  const isIndexFull =
    snapshotIndex === 0
      ? snapshotIndex === snapshots.length
      : snapshotIndex === snapshots.length - 1

  return isEmptyList || isIndexFull || isSnapshotInProgress
}

export function getRedoStatus(state: RootState, builderId: string) {
  const snapshots = getSnapshotList(state, builderId)
  const snapshotIndex = getSnapshotIndex(state, builderId)
  const isSnapshotInProgress = getSnapshotInstallationStatus(state, builderId)
  const isEmptyList = !snapshots.length
  const isIndexInitial = snapshotIndex === 0

  return isEmptyList || isIndexInitial || isSnapshotInProgress
}
